import React from 'react';

import { v4 as uuid } from 'uuid';

import './BdsStepsIndicator.scss';
import { IBdsStepsIndicator } from '../../../interfaces/bdsStepsIndicator';

const BdsStepsIndicator = ({ steps, active, variant, changeStep }: IBdsStepsIndicator) => {
  const verifyChangeStep = (index: number) => {
    if (changeStep && index !== active) {
      changeStep(index);
    }
  };

  return (
    <div className={'bds-steps-indicator-container'}>
      {[...Array(steps).keys()].map((item, index) => (
        <React.Fragment key={`bds-steps-indicator${item}-${uuid()}`}>
          <button
            className={`
              bds-steps-indicator-item
              ${variant?.includes('circle') ? 'circle' : 'line'}
              ${index === active ? 'active' : ''}
              ${index === active && variant?.includes('accent') ? 'accent' : ''}
            `}
            onClick={() => verifyChangeStep(index)}
            aria-current={index === active ? 'step' : undefined}
          ></button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default BdsStepsIndicator;
